import slMessages from './lang/sl.json';
import enMessages from './lang/en.json';

export type Language = 'sl' | 'en';

const messages: Record<Language, Record<string, string>> = { sl: slMessages, en: enMessages };
const englishText: Record<string, string> = enMessages;
const slovenianText: Record<string, string> = slMessages;


export function detectLanguage(language = navigator.language): Language {
  return /^sl(?:-|$)/i.test(language) ? 'sl' : 'en';
}

export function getInitialLanguage(): Language {
  try {
    const saved = localStorage.getItem('photocollage-language');
    if (saved === 'sl' || saved === 'en') return saved;
  } catch { /* Use the system language if browser storage is unavailable. */ }
  return detectLanguage();
}

export function saveLanguage(language: Language): void {
  try { localStorage.setItem('photocollage-language', language); }
  catch { /* Keep the selected language for this session. */ }
}

export function translate(key: string, language = detectLanguage()): string {
  return messages[language][key] ?? key;
}

export function formatMessage(key: string, values: Record<string, string | number>, language = detectLanguage()): string {
  return translate(key, language).replace(/\{([a-zA-Z]+)\}/g, (_, name: string) => String(values[name] ?? ''));
}

export function translateText(text: string, language = detectLanguage()): string {
  if (language === 'sl') return slovenianText[text] ?? text;
  const exact = englishText[text];
  if (exact) return exact;
  for (const [source, target] of Object.entries(englishText)) {
    if (source.endsWith(' ') && text.startsWith(source)) return `${target}${text.slice(source.length)}`;
  }
  const colonIndex = text.indexOf(': ');
  if (colonIndex >= 0) {
    const suffix = text.slice(colonIndex + 2);
    const translatedSuffix = englishText[suffix];
    if (translatedSuffix) return `${text.slice(0, colonIndex)}: ${translatedSuffix}`;
  }
  return text;
}
